import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSEquipmentCellModule, NSErrorModule, NSGridActionCellModule, NSGridModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { PreviousRequestsFormModule } from '@ruby/modules/diversions/forms/previous-requests/previous-requests-form.module';
import { DiversionsReviewModule } from '@ruby/modules/diversions/forms/review/diversions.review.module';
import { PreviousRequestsCellComponent } from '@ruby/modules/diversions/submodules/previous-requests/components/previous-requests-cell/previous-requests-cell.component';
import { PreviousRequestsComponent } from '@ruby/modules/diversions/submodules/previous-requests/components/previous-requests.component';
import { RequestDetailHeaderComponent } from '@ruby/modules/diversions/submodules/previous-requests/components/request-detail-header/request-detail-header.component';
import { RequestDetailComponent } from '@ruby/modules/diversions/submodules/previous-requests/components/request-detail/request-detail.component';
import { WaybillPrintCellComponent } from '@ruby/modules/diversions/submodules/previous-requests/components/waybill-print-cell/waybill-print-cell.component';
import { PreviousRequestContainer } from '@ruby/modules/diversions/submodules/previous-requests/containers/previous-requests.container';
import { RequestDetailContainer } from '@ruby/modules/diversions/submodules/previous-requests/containers/request-detail/request-detail.container';
import { PreviousRequestsRoutingModule } from '@ruby/modules/diversions/submodules/previous-requests/previous-requests-routing.module';
import { DiversionsCancelModule } from '@ruby/shared/dialogs/diversions/diversions-cancel/diversions-cancel.module';
import { DiversionsCompleteModule } from '@ruby/shared/dialogs/diversions/diversions-complete/diversions-complete.module';
import { EventHistoryModule } from '@ruby/shared/dialogs/diversions/event-history/event-history.module';
import { DiversionsOriginalLocationModule } from '@ruby/shared/dialogs/diversions/original-location/original-location.module';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [
    PreviousRequestsCellComponent,
    WaybillPrintCellComponent,
    PreviousRequestContainer,
    PreviousRequestsComponent,
    RequestDetailContainer,
    RequestDetailComponent,
    RequestDetailHeaderComponent

  ],
  imports: [
    FormsModule,
    CommonModule,
    DiversionsOriginalLocationModule,
    EventHistoryModule,
    DiversionsReviewModule,
    DiversionsCancelModule,
    DiversionsCompleteModule,
    PreviousRequestsRoutingModule,
    PreviousRequestsFormModule,
    NSGridActionCellModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    NSEquipmentCellModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatTooltipModule,
    NSErrorModule,
    MatToolbarModule,
    NSSkeletonModule,
    MatProgressSpinnerModule,
    PipesModule,
    ReactiveFormsModule
  ],
  exports: [PreviousRequestContainer, RequestDetailContainer],
  providers: []
})
export class previousRequestsModule {}
